// extracted by mini-css-extract-plugin
export default {"footerbar":"FooterBar_footerbar__WR14Q","p1":"FooterBar_p1__h32kJ","p2":"FooterBar_p2__G9xWn","redes":"FooterBar_redes__+Bvbk"};